// https://cloud.google.com/translate/docs/languages

const en = [
    { name: 'English', key: 'en' },
    { name: 'Bengali', key: 'bn' },
    { name: 'Gujarati', key: 'gu' },
    { name: 'Hindi', key: 'hi' },
    { name: 'Kannada', key: 'kn' },
    { name: 'Malayalam', key: 'ml' },
    { name: 'Marathi', key: 'mr' },
    { name: 'Nepali', key: 'ne' },
    { name: 'Odiya', key: 'or' },
    { name: 'Punjabi', key: 'pa' },
    { name: 'Sinhala', key: 'si' },
    { name: 'Tamil', key: 'ta' },
    { name: 'Telugu', key: 'te' },
    { name: 'Urdu', key: 'ur' },
];

const languages = {
    en,
};

export default languages;
